import axios from '@/axios.js'

const state = () => ({
  anggarans: [],
  total: null,
  last: null
})

const mutations = {
  SET_ANGGARANS (state, payload) {
    state.anggarans = payload
  },
  SET_TOTALS (state, payload) {
    state.total = payload
  },
  SET_LAST (state, payload) {
    state.last = payload
  },
  PUSH_ANGGARANS (state, item) {
    state.anggarans.push(item)
  },
  ADD_ANGGARAN (state, item) {
    state.anggarans.unshift(item)
  },
  UPDATE_ANGGARAN (state, anggaran) {
    const anggaranIndex = state.anggarans.findIndex((p) => p.id === anggaran.task_parent)
    Object.assign(state.anggarans[anggaranIndex], anggaran)
  },
  REMOVE_ANGGARAN (state, itemId) {
    const ItemIndex = state.anggarans.findIndex((p) => p.id === itemId)
    state.anggarans.splice(ItemIndex, 1)
  },
}

const actions = {
  fetchAnggaran ({ commit }, obj) {
    return new Promise((resolve, reject) => {
      axios.get(`/task-list-anggaran/${obj.search}?page=${obj.page}`)
        .then((response) => {
          if (obj.action === 'create') {
            commit('SET_ANGGARANS', response.data.data.tasks)
            commit('SET_TOTALS', response.data.data.total)
            commit('SET_LAST', response.data.data.last_page)
          } else {
            for (let i = 0; i < response.data.data.tasks.length; i++) {
              commit('PUSH_ANGGARANS', response.data.data.tasks[i])
            }
          }
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  addAnggaran ({ commit }, task) {
    return new Promise((resolve, reject) => {
      axios.post('/task-add-anggaran', task)
        .then((response) => {
          commit('ADD_ANGGARAN', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateAnggaran ({ commit }, task) {
    return new Promise((resolve, reject) => {
      axios.post(`/task-update-anggaran/`, task)
        .then((response) => {
          commit('UPDATE_ANGGARAN', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeTask ({ commit }, taskId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/task-delete-anggaran/${taskId}`)
        .then((response) => {
          commit('REMOVE_ANGGARAN', taskId)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  }
}

export default {
  isRegistered: false,
  namespaced: true,
  state,
  actions,
  mutations
}